export const stickyTabsAnchors = {
  promotions: 'tab-promotions',
  description: 'tab-description',
  euLabels: 'tab-euLabels',
  parameters: 'tab-parameters',
  rating: 'tab-rating',
  certificate: 'tab-certificate',
  delivery: 'tab-delivery',
  payments: 'tab-payments',
  warranty: 'tab-warranty',
  returns: 'tab-returns',
  availableSizes: 'tab-available-sizes',
} as const;
